// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ezgn","rightAdornment":"Header_rightAdornment__sD52c"};